export enum SurgicalApproach {
    DirectAnterior = 'Direct Anterior',
    DirectPosterior = 'Posterior',
}

export interface SurgicalApproachOption {
    label: string;
    value: string;
}

/**
 * Surgical-approach catalogue — static reference data.
 *
 * `value` is the backend `surgical_approaches.id` (a persisted foreign key on
 * every case and surgeon preference), so these IDs must stay in lock-step with
 * the database. Adding or renaming an approach therefore requires a coordinated
 * backend migration and a change here.
 */
export const SURGICAL_APPROACHES: SurgicalApproachOption[] = [
    { label: SurgicalApproach.DirectAnterior, value: '1' },
    { label: SurgicalApproach.DirectPosterior, value: '2' },
];